module.exports = __webpack_public_path__ + "static/combinations-7359c97a96e9aab2ede7e818070a01f0.png";